import { Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import iconExcel from "../../assets/images/timeKeeping/excel.svg";
import { exportFile } from "../../utils/tools";
import { useState } from "react";
import { useEffect } from "react";
import { saleOpeningEventCall } from "../../api/saleOpeningEvent";
import toast from "react-hot-toast";

export default function Step1({
  saleOpeningEventId,
  handleNext,
  handlePrevious,
}) {
  const [product, setProduct] = useState([]);

  const getProject = async (saleOpeningEventId) => {
    try {
      const data = await saleOpeningEventCall.getId(saleOpeningEventId);

      if (data?.apartmentSaleOpeningEventLink) {
        setProduct(data.apartmentSaleOpeningEventLink);
      }
    } catch (error) {
      console.error("Error", error);
      toast.error("Có lỗi xảy ra khi lấy ra dự án");
    }
  };

  useEffect(() => {
    if (saleOpeningEventId) {
      getProject(saleOpeningEventId);
    }
  }, [saleOpeningEventId]);

  const handleEmployeeExportSample = () => {
    const columnMapping = {
      apartment: "Mã căn",
      priceForCommission: "Giá tính phí dịch vụ",
      rateTNSan: "Tỉ lệ TN sàn",
      priceTNSan: "Số tiền TN sàn",
      transactionRate: "Tỉ lệ nhận về"
    };

    const data = product?.map((item) => ({
      apartment: item?.apartmentObject?.code,
      priceForCommission: Number(item?.apartment?.priceForCommission || 0),
      rateTNSan: Number(item?.apartment?.rateTNSan || 0),
      priceTNSan: Number(item?.apartment?.priceTNSan || 0),
      transactionRate: Number(item?.apartment?.transactionRate || 0)
    }));

    try {
      exportFile(data, columnMapping, "Can_ho_trong_dot_mo_ban.xlsx");
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };
  return (
    <Flex flexDirection={"column"} h={"calc(100vh - 254px)"}>
      <Flex
        flex={1}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Button
          display={"flex"}
          alignItems={"center"}
          p={"10px 16px 10px 12px"}
          gap={"8px"}
          backgroundImage="var(--color-gradient-excel)"
          _hover={{
            backgroundImage: "var(--color-gradient-excel)",
          }}
          onClick={() => handleEmployeeExportSample()}
        >
          <Image src={iconExcel} />
          <Text fontSize="15px" fontWeight="600" color="var(--color-main)">
            Export căn hộ có trong đợt mở bán
          </Text>
        </Button>
        <Text mt={"24px"} color={"var(--color-option-employee-hover)"}>
          (Tải về danh sách các căn hộ có trong đợt mở bán, nếu bạn có rồi thì
          có thể chuyển tiếp bước 2)
        </Text>
      </Flex>
      <Box>
        <Flex justifyContent={"flex-end"} alignItems={"center"}>
          <Button
            display="flex"
            alignItems="center"
            p="10px 16px"
            h={"44px"}
            gap="8px"
            backgroundImage="var(--color-button)"
            onClick={() => handleNext(1)}
            _hover={{
              filter: "brightness(90%)",
            }}
          >
            <Text fontSize="15px" fontWeight="600" color="var(--color-main)">
              Chuyển sang bước 2
            </Text>
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
}
